import React from "react";

export default function NotificationIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.6 16.8c.33-.44.95-.54 1.39-.21.52.39 1.08.81 1.61 1.21.44.32.53.94.2 1.38l-.01.02c-.32.44-.94.53-1.38.2-.53-.4-1.09-.82-1.62-1.21a.966.966 0 0 1-.2-1.37s.01-.01.01-.02zM13 6v12l-5-3H7v3c0 .55-.45 1-1 1l-.116-.007A1.004 1.004 0 0 1 5 18v-3H4c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2h4l5-3zm1 2.65c.92.82 1.5 2.02 1.5 3.35s-.58 2.53-1.5 3.34zM21 11c.55 0 1 .45 1 1l-.007.116A1.004 1.004 0 0 1 21 13h-2c-.55 0-1-.45-1-1l.007-.116c.058-.496.482-.884.993-.884zm-2.58-6.41a.98.98 0 0 1 1.38.2l.01.02c.32.44.24 1.06-.19 1.38-.53.4-1.09.83-1.62 1.22a.98.98 0 0 1-1.38-.2l-.01-.02a.979.979 0 0 1 .19-1.38c.52-.4 1.09-.82 1.62-1.22z" fill="#4C4F59" fillRule="nonzero"/>
        </svg>
    );
}
